/**
 * @generated SignedSource<<9fc94054a06163009b01f7a09e8bceab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamType = "CHECKOUT" | "FLOOR";
import { FragmentRefs } from "relay-runtime";
export type TeamAdminLayout_Team$data = {
  readonly availableFeatures: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly isHidden: boolean;
    readonly pinnedOrder: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"TeamAdminLayoutFeature_TeamFeature">;
  }>;
  readonly color: string | null;
  readonly id: string;
  readonly type: TeamType;
  readonly " $fragmentType": "TeamAdminLayout_Team";
};
export type TeamAdminLayout_Team$key = {
  readonly " $data"?: TeamAdminLayout_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamAdminLayout_Team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamAdminLayout_Team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "availableFeatures",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isHidden",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pinnedOrder",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamAdminLayoutFeature_TeamFeature"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "adfa3b75f4bc026c35a34e6a7c0c094e";

export default node;
